import { get } from 'lodash/fp';
import { convertJobToDesign } from '../../api/mandi';
import { loadDesign } from '../../api/designBuilder';

export default (newDesignName, currentDesign) => (
  convertJobToDesign(
    get('attributes.jobUid', currentDesign),
    newDesignName,
  )
    .then(loadDesign)
);
